export { default as RoutineDetail } from "./RoutineDetail";

